module.exports = __webpack_public_path__ + "img/icon_gongneng3.7dabc369.svg";